import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import UserList from './widgets/UserList'
import { Link } from 'react-router-dom'
import Nav from './widgets/Nav'
import Util from '../util/util'
import ReactModal from 'react-modal'
import ListErrors from './widgets/ListErrors'
import {
  GROUP_DETAIL_PAGE_LOADED,
  GROUP_DETAIL_PAGE_UNLOADED,
  GROUP_REMOVE,
  GROUP_UPDATE,
  GROUP_ASSIGN_USER,
  CONFIRM_REDIRECT_TO
} from '../constants/actionTypes'
import _ from 'lodash'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const mapStateToProps = state => ({
  ...state.file,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: GROUP_DETAIL_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: GROUP_DETAIL_PAGE_UNLOADED }),
  onDelete: (payload) => {
    dispatch({ type: GROUP_REMOVE, payload })
  },
  onUpdate: (payload) => {
    dispatch({ type: GROUP_UPDATE, payload })
  },
  onAssignUser: (payload) => {
    dispatch({ type: GROUP_ASSIGN_USER, payload })
  },
  onConfirmRedirect: (key) => {
    dispatch({
      type: CONFIRM_REDIRECT_TO, confirmInfo: {
        type: 'groups',
        confirmTitle: 'Update Successful',
        confirmText: 'Group details updated.',
        nextRoute: `/groups/${key}`,
        nextRouteText: 'Back',
      }
    })
  },
})

class GroupDetail extends React.Component {
  constructor() {
    super()
    this.state = {
      name: '',
      key: '',
      email: ''
    }
    this.updateState = field => ev => {
      const state = this.state
      const newState = Object.assign({}, state, { [field]: ev.target.value })
      this.setState(newState)
    }
    this.deleteGroup = (key) => ev => {
      ev.preventDefault()
      if (window.confirm(i18n.t('file.delete_group_confirm_text'))) {
        const payload = agent.Files.removeGroup(key)
        this.props.onDelete(payload)
      }
    }
    this.updateGroup = () => ev => {
      ev.preventDefault()
      const name = this.state.name
      const key = this.state.key
      const payload = agent.Files.updateGroup(key, name)
      this.props.onUpdate(payload)
    }
    this.addUserToGroup = () => ev => {
      ev.preventDefault()
      const email = this.state.email
      const key = this.state.key
      const payload = agent.Files.assignUserToGroup(key, email)
      this.props.onAssignUser(payload)
    }
  }
  componentWillMount() {
    if (this.props.currentUser) {
      const key = this.props.match.params.key
      const payload = agent.Files.getGroup(key)
      this.props.onLoad(payload)
    } else {
      store.dispatch(push("/login"))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.updated === true) {
      this.props.onConfirmRedirect(this.props.match.params.key)
      this.props.onUnload()
    } else if (nextProps.group && nextProps.group !== this.props.group) {
      Object.assign(this.state, {
        key: nextProps.group.key,
        name: nextProps.group.name
      })
    }
  }

  componentWillUnmount() {
    this.props.onUnload()
  }

  render() {
    if (!this.props.group) {
      return (
        <Loading selected={'groups'} currentUser={this.props.currentUser} />
      )
    }
    const group = this.props.group
    const name = this.state.name
    const email = this.state.email
    return (
      <Translation>
        {
          (t) => (
            <div id="main">
              <Nav selected={'groups'} currentUser={this.props.currentUser} />
              <div id="content">
                <Header />
                <div id="content-clear">
                  <div className="focus-wrap">
                    <div className='box-header'>
                      <span className='header-info'>{t('file.label_created')}: {group.created}</span>
                      <h2>{t('file.group_user_title')}</h2>
                    </div>
                    <div className="form-item">
                      <label>{t('file.label_email')}</label>
                      <input type="text" placeholder="john@hello.com" value={email} onChange={this.updateState('email')} />
                    </div>
                    <div className="form-item">
                      <button type="button" onClick={this.addUserToGroup()}>{t('file.assign_user_button')}</button>
                    </div>
                    <ListErrors errors={this.props.errors} />
                  </div>

                  {
                    group.group_users.length > 0 ?
                      <div className="focus-wrap">
                        <div className='box-header'>
                          <h2>{t('file.user_group_title')}</h2>
                        </div>
                        <UserList groupkey={group.key} data={group.group_users} />
                      </div> : null
                  }

                  {
                    group.group_users.length > 0 ?
                      <div className="focus-wrap">
                        <div className='box-header'>
                          <h2>{t('file.group_edit_title')}</h2>
                        </div>
                        <div className="form-item">
                          <label>{t('file.label_name')}</label>
                          <input type="text" value={name} onChange={this.updateState('name')} />
                        </div>
                        <div className="form-item">
                          <button type="button" onClick={this.updateGroup()}>{t('file.update_group_button')}</button>
                        </div>
                        <div className="form-item">
                          <button type="button" className={'light-button'} onClick={this.deleteGroup(group.key)}>{t('file.delete_group_button')}</button>
                        </div>
                      </div> : null
                  }
                </div>
              </div>
            </div >
          )
        }
      </Translation>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDetail)
